export type EventHandler<T> = (msg?: T) => void|any;

export default class Bus<T> {

    handlers: {[k: string]: EventHandler<T>[]} = {};

    public on(eventName: string, handler: EventHandler<T>) {
        if (!this.handlers.hasOwnProperty(eventName)) {
            this.handlers[eventName] = [];
        }

        this.handlers[eventName].push(handler);
    }

    public off(eventName: string, handler?: EventHandler<T>) {
        if (this.handlers.hasOwnProperty(eventName) && undefined === handler) {
            this.handlers[eventName] = [];
        } else if (this.handlers.hasOwnProperty(eventName)) {
            this.handlers[eventName] = this.handlers[eventName].filter(handlerFn => handlerFn !== handler);
        }
    }

    public trigger(eventName: string, msg?: T) {
        if (this.handlers.hasOwnProperty(eventName) && this.handlers[eventName].length) {
            this.handlers[eventName].forEach(
                handler => {
                    handler(msg);
                }
            );
        }
    }

    public clear() {
        this.handlers = {};
    }

    public listenerCount(eventName: string): number {
        if (!this.handlers.hasOwnProperty(eventName)) {
            return 0;
        }

        return this.handlers[eventName].length;
    }
}